import { useState } from "react";
import { Link } from "react-router";
import { patch, post } from "../api";
import { PublicShell } from "../layout";
import { modules } from "../modules";
import { useSession, ROLE_LABELS } from "../session";
import { Button, Card, ErrorBox, Input, Select, fieldError, useToast } from "../ui";

/** Espace personnel : profil, sécurité, et accès candidat / locataire fournis par les modules. */
export function AccountPage() {
  const { user, memberships, refresh } = useSession();
  const toast = useToast();
  const [profile, setProfile] = useState({ full_name: user?.full_name ?? "", phone: user?.phone ?? "", locale: user?.locale ?? "fr" });
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  const [error, setError] = useState<unknown>(null);
  const [pwdError, setPwdError] = useState<unknown>(null);
  const links = modules.flatMap((m) => m.accountNav ?? []);
  return (
    <PublicShell wide>
      <h1>Mon espace personnel</h1>
      <div className="grid-2">
        <div className="stack">
          {links.length ? (
            <Card title="Mes démarches">
              <ul className="list-plain">
                {links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </Card>
          ) : null}
          <Card title="Mes espaces bailleur">
            {memberships.length ? (
              <ul className="list-plain">
                {memberships.map((m) => (
                  <li key={m.org_id}>
                    <Link to={`/espace/${m.org_id}`}>{m.org_name}</Link> <span className="muted small">· {ROLE_LABELS[m.role]}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="muted">
                Aucun espace. <Link to="/espaces?nouveau=1">Créer un espace bailleur</Link>
              </p>
            )}
          </Card>
        </div>
        <div className="stack">
          <Card title="Profil">
            <form
              className="stack"
              onSubmit={async (e) => {
                e.preventDefault();
                setError(null);
                try {
                  await patch("/api/v1/me", profile);
                  await refresh();
                  toast("Profil enregistré.");
                } catch (err) {
                  setError(err);
                }
              }}
            >
              <ErrorBox error={error} />
              <Input label="Nom et prénom" value={profile.full_name} error={fieldError(error, "full_name")} onChange={(e) => setProfile({ ...profile, full_name: e.target.value })} />
              <Input label="Adresse e-mail" value={user?.email ?? ""} disabled help="Pour changer d’adresse, contactez l’assistance." />
              <Input label="Téléphone" type="tel" value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} />
              <Select
                label="Langue"
                value={profile.locale}
                options={[
                  { value: "fr", label: "Français" },
                  { value: "en", label: "English" },
                ]}
                onChange={(e) => setProfile({ ...profile, locale: e.target.value })}
              />
              <Button type="submit">Enregistrer</Button>
            </form>
          </Card>
          <Card title="Mot de passe">
            <form
              className="stack"
              onSubmit={async (e) => {
                e.preventDefault();
                setPwdError(null);
                try {
                  await post("/api/v1/me/password", pwd);
                  setPwd({ current_password: "", new_password: "" });
                  toast("Mot de passe modifié. Vos autres sessions ont été fermées.");
                } catch (err) {
                  setPwdError(err);
                }
              }}
            >
              <Input label="Mot de passe actuel" type="password" autoComplete="current-password" value={pwd.current_password} error={fieldError(pwdError, "current_password")} onChange={(e) => setPwd({ ...pwd, current_password: e.target.value })} />
              <Input label="Nouveau mot de passe" type="password" autoComplete="new-password" value={pwd.new_password} error={fieldError(pwdError, "new_password")} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} />
              <Button type="submit" variant="secondaire">
                Changer le mot de passe
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </PublicShell>
  );
}
